<script lang="ts">
  let props = $props()
  let user = props.user
</script>

{#if ["admin", "leader", "manager"].includes(user.role)}
  <span
    class="text-full-access-dk bg-full-access-lt px-2 py-1 text-sm font-medium rounded-md"
  >
    Full-Access
  </span>
{:else if user.role === "member"}
  <span
    class="text-team-member-dk bg-team-member-lt px-2 py-1 text-sm font-medium rounded-md"
  >
    Team Member
  </span>
{:else if user.role === "recognition"}
  <span
    class="text-recognition-dk bg-recognition-lt px-2 py-1 text-sm font-medium rounded-md"
  >
    Recognition
  </span>
{/if}
